var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('h1',{style:({'font-size': _vm.font})},[_vm._t("default"),(_vm.showCursor)?_c('span',{staticClass:"cursor",style:({'margin-top': _vm.margin })}):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }